import { render } from "./PaymentsAdjustmentsTab.vue?vue&type=template&id=abd8f8c8"
import script from "./PaymentsAdjustmentsTab.vue?vue&type=script&lang=js"
export * from "./PaymentsAdjustmentsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/AccountReceivable/PaymentsAdjustmentsTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "abd8f8c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('abd8f8c8', __exports__)) {
    api.reload('abd8f8c8', __exports__)
  }
  
  module.hot.accept("./PaymentsAdjustmentsTab.vue?vue&type=template&id=abd8f8c8", () => {
    api.rerender('abd8f8c8', render)
  })

}


export default __exports__